<template>
  <h2 v-if="hakenListData">{{ hakenListData.userName }}（社員番号：{{ hakenListData.staffCode ? hakenListData.staffCode : '-'
    }}）さんの勤務記録</h2>
  <div class="container">

    <div class="kinmu-list-header flex">
      <div class="control">
        <p class="name" v-if="hakenListData">{{ hakenListData.userName }}（社員番号：{{ hakenListData.staffCode ?
    hakenListData.staffCode : '-' }}）<span>さんの</span></p>
        <div class="location"
          v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) && syuugyouBasyoOptions">
          <select v-model="selectedSyuugyouBasyoOption" @change="changeSyuugyouBasyo" :disabled="isLoading">
            <option v-for="syuugyoubasyo in syuugyouBasyoOptions" :value="syuugyoubasyo" :key="syuugyoubasyo.koyou_id"
              :selected="selectedSyuugyouBasyoOption?.koyou_id === syuugyoubasyo.koyou_id">{{ syuugyoubasyo.label }}
            </option>
          </select>
        </div>

        <div class="period-selecter">
          <month-picker v-model="yearMonthForMonthPicker" @update:modelValue="changeMonth" :disabled="isLoading"
            :clearable=false></month-picker>
          <span>のタイムシートを表示中です</span>
        </div>

        <div class="flex" v-if="hakenListData">
          <!-- <p class="p-btn">
            <button v-if="!hakenListData.isClosed" class="btn success" :disabled="hakenListData.isSendedPx || isLoading"
              @click="switchCloseKintaiSummary(true)">タイムシート確定（締め）</button>
            <button v-else class="btn warning" :disabled="hakenListData.isSendedPx || isLoading"
              @click="switchCloseKintaiSummary()">確定（締め）解除</button>
          </p> -->

          <template v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
            <div class="p-btn-container">
              <p class="p-btn">
                <button class="btn info" v-on:click="saveSoumuInfo" :disabled="isLoading">総務編集を保存</button>
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>

    <loading v-if="isLoading"></loading>
    <p v-else-if="!hakenListData || hakenListData.isAfterTaisyokuMonth">該当するデータはありません</p>
    <p v-else-if="hakenListData.isAfterTaisyokuMonth">退職後の月のため表示できません</p>
    <template v-else-if="!isLoading && hakenListData">
      <p v-if="hakenListData.isSendedPx">このタイムシートはすでにPX連携が行われているため状態変更を行えません</p>

      <template v-if="hakenListData.list.length > 0">
        <section class="table-wrapper">
          <p>出勤、退勤が赤くなっている行は計算に必要な打刻が不足している行です。（非表示の外出と戻り打刻も含みます）<br>
            打刻者による打刻を待つか打刻修正申請を提出してもらってください。
          </p>
          <scroll-table>
            <table class="kinmu-table">
              <thead>
                <tr class="kinmu-table-header-row">
                  <!-- 左側 -->
                  <th rowspan="2">日付</th>
                  <th rowspan="2">有休取得</th>
                  <th rowspan="2">出勤<br />（打刻時間）</th>
                  <th rowspan="2">退勤<br />（打刻時間）</th>
                  <th rowspan="2">休憩</th>
                  <th rowspan="2">勤務時間</th>
                  <th rowspan="2">法定内残業</th>
                  <th rowspan="2">時間外</th>
                  <th rowspan="2">深夜割増</th>
                  <th rowspan="2">備考</th>
                  <th class="medica-memo" v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)"
                    colspan="3">
                    メディカによる補正欄</th>
                  <th class="medica-memo" v-else colspan="2">メディカによる補正欄</th>
                </tr>

                <tr class="kinmu-table-header-row">
                  <th class="medica-memo">メモ</th>
                  <th class="medica-memo">時間<br>(単位：時)</th>
                  <th class="medica-memo" v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">データ</th>
                </tr>
              </thead>

              <tbody>
                <template v-for="(item) in hakenListData.list">
                  <template v-if="item.kinmus.length > 0">
                    <tr class="kinmu-table-data-row"
                      :class="{ 'uncomplete': kinmu.isUncomplete, 'need-kyuukei': kinmu.isNeedKyuukei }"
                      v-for="(kinmu, index) in item.kinmus" :key="kinmu.dakoku_id">

                      <!-- 左側 -->
                      <td class="date" v-if="index === 0" :rowspan="item.kinmus.length"
                        v-bind:class="{ 'color-red': item.date_for_display.substr(-2, 1) == '日' }">

                        {{ item.date_for_display }}

                        <shinseis-title :shinseis="item.shinseis" :kinmu="kinmu" :year="selectedYear"
                          :month="selectedMonth"></shinseis-title>

                      </td>
                      <td>
                        <template v-if="kinmu.is_yuukyuu">
                          <p>◯</p>
                        </template>
                      </td>
                      <td class="syukkin">
                        {{ timeFormat(kinmu.syukkin_round_datetime) }}
                        <span v-if="kinmu.syukkin_round_datetime"><br />
                          ({{ timeFormat(kinmu.syukkin_datetime) }})
                        </span>
                      </td>
                      <td class="taikin">
                        {{ timeFormat(kinmu.taikin_round_datetime) }}
                        <span v-if="kinmu.taikin_datetime"><br />
                          ({{ timeFormat(kinmu.taikin_datetime) }})
                        </span>
                      </td>
                      <td class="kyuukei">{{ kinmu.kyuukei_times }}</td>
                      <td class="syotei-work-time">{{ kinmu.syotei_work_times }}</td>
                      <td class="houteinai-work-time">
                        {{ kinmu.houteinai_zangyou_times }}
                      </td>
                      <td class="jikangai-work-time">
                        {{ kinmu.jikangai_work_times }}
                      </td>
                      <td class="shinya-warimashi-times">
                        {{ kinmu.shinya_warimashi_times }}
                      </td>
                      <td class="chikoku-time">
                        <template v-if="kinmu.chikoku_times">
                          <p>遅刻{{ kinmu.chikoku_times }}</p>
                        </template>
                        <template v-if="kinmu.soutai_times">
                          <p>早退{{ kinmu.soutai_times }}</p>
                        </template>
                      </td>

                      <td class="medica-memo"
                        :class="{ view: !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) }">
                        <template v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
                          <input-text type="text" max-length="128" v-model="kinmu.soumu_note1"></input-text>
                        </template>
                        <template v-else>
                          <p>{{ kinmu.soumu_note1 }}</p>
                        </template>

                        <template v-if="kinmu.yuukyuu_times">
                          有給{{ kinmu.yuukyuu_times }}
                        </template>
                      </td>
                      <td class="medica-memo"
                        :class="{ view: !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) }">
                        <template v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
                          <input-text type="number" max-length="128" v-model="kinmu.soumu_note2"
                            v-on:change="calcProc()"></input-text>
                        </template>
                        <template v-else>
                          <p>{{ kinmu.soumu_note2 }}</p>
                        </template>
                      </td>
                      <td class="medica-memo"
                        :class="{ view: !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) }"
                        v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
                        {{ (kinmu.soumu_note1 != '' || kinmu.soumu_note2 != '') ? kinmu.modifiedKinmuTimes : '' }}</td>
                    </tr>
                  </template>

                </template>

                <tr class="kinmu-table-data-row">
                  <td>計</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ sumKinmuTime }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="medica-memo"
                    :class="{ view: !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) }"></td>
                  <td class="medica-memo"
                    :class="{ view: !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) }">{{
    allSoumuModifyTime }}</td>
                  <td class="medica-memo"
                    :class="{ view: !authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN) }"
                    v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">{{ sumAfterModify }}</td>
                </tr>
              </tbody>
            </table>
          </scroll-table>
        </section>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import { useHakenKinmuList } from "@/composable/kinmu/hakenlist";
import { defineComponent, onMounted, Ref, ref } from "vue";
import { timeFormat } from "@/filters/common";
import OptionConst from "@/const/Option";
import { MonthPickerModelValue } from "../form/MonthPicker.vue";
import KinmuSummary from '@/components/kinmu/Summary.vue';
import { useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth";
import { PermissionConst } from "@/const/Permission";
import { DialogService } from '@/service/DialogService';
import dayjs from "dayjs";
import { HakenModifyDatas, SetSoumuModifyData } from "@/types/Dakoku";
import { useRouter } from 'vue-router';
import { RouterConst } from "@/const/Router";
import { cloneDeep } from "lodash";
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init";
import { useKintaiSummary } from "@/composable/kinmu/summary";
import ShinseisTitle from '@/components/kinmu/ShinseisTitle.vue';
import Message from "@/const/Message";

export default defineComponent({
  setup() {
    const { hakenListData, sumKinmuTime, sumAfterModify, setHakenModifies, getHakenKinmuListBySummaryId, getHakenKinmuListByPeriod } = useHakenKinmuList();
    const { closeKintaiSummary, closeCancelKintaiSummary, getKintaiSummaryBySummaryId } = useKintaiSummary();
    const route = useRoute()
    const authStore = useAuthStore()
    const router = useRouter()

    const selectedYear: Ref<number> = ref(new Date().getFullYear())
    const selectedMonth: Ref<number> = ref(new Date().getMonth() + 1)

    // MonthPickerに渡すための年月obj
    const yearMonthForMonthPicker: Ref<MonthPickerModelValue> = ref({
      year: selectedYear.value,
      month: selectedMonth.value - 1
    })

    const isLoading = ref(false)
    const { syuugyouBasyoOptions, getSyuugyouBasyoOptionByUserId, selectedSyuugyouBasyoOption } = useSyuugyouBasyoInit();

    let userId = ref(route.query.user_id ? parseInt(route.query.user_id as string, 10) : null)
    if (userId.value == null && route.query.targetUserId != null) {
      userId.value = parseInt(route.query.targetUserId as string, 10)
    }
    const kintaiSummaryId: Ref<number | null> = ref(null)

    onMounted(async () => {
      isLoading.value = true
      kintaiSummaryId.value = route.params.kintaiSummaryId ? parseInt(route.params.kintaiSummaryId as string, 10) : null

      if (route.query.user_id) {
        userId.value = route.query.user_id ? parseInt(route.query.user_id as string, 10) : null
      }

      // 前画面から年が渡された場合（＝前画面時点でサマリーIDが取得できない＝未打刻の年月の場合）
      if (route.query.year) {
        selectedYear.value = parseInt(route.query.year as string, 10)
      }

      // 前画面から月が渡された場合（＝前画面時点でサマリーIDが取得できない＝未打刻の年月の場合）
      if (route.query.month) {
        selectedMonth.value = parseInt(route.query.month as string, 10)
      }

      if (!kintaiSummaryId.value && (!selectedYear.value || !selectedMonth.value || !userId.value)) {
        await DialogService.error({
          html: '勤怠情報の取得に必要な情報が不足しています。<br>お手数ですが最初からやり直してください。'
        })
        router.push({ name: RouterConst.HAKEN_KINMU_LIST })
        return
      }

      if (kintaiSummaryId.value) {
        // サマリーIDがある場合はサマリーIDを元に勤務一覧を取得
        await loadKinmuListBySummaryId()
      } else {
        // サマリーIDがない場合はユーザーID、年月、就業場所ID、雇用契約IDから勤務一覧を取得
        await loadKinmuListByPeriod()
      }

      if (!hakenListData.value) {
        isLoading.value = false
        return
      }

      // サーバーから取得した情報で各種変数を上書き
      // この時点では前画面から受け取った情報により変数の状況が異なるため、サーバーから受け取った値で合わせる
      userId.value = hakenListData.value.userId
      selectedYear.value = hakenListData.value.year
      selectedMonth.value = hakenListData.value.month
      yearMonthForMonthPicker.value = {
        year: selectedYear.value,
        month: selectedMonth.value - 1
      }

      if (authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)) {
        // 総務は就業場所の選択を行うことができる
        // また、過去の雇用契約も含めすべての雇用契約を見れる必要があるためshowOldKeiyakuはtrue
        await getSyuugyouBasyoOptionByUserId(hakenListData.value.userId, true);

        // 取得した一覧とURLで渡された雇用契約IDが一致するものを選択中の就業場所として扱う
        if (syuugyouBasyoOptions.value.length > 0) {
          const matched = syuugyouBasyoOptions.value.find((item) => { return item.koyou_id === hakenListData.value?.koyouKeiyakuId })
          if (matched) {
            selectedSyuugyouBasyoOption.value = matched;
          } else {
            selectedSyuugyouBasyoOption.value = syuugyouBasyoOptions.value[0]

            // 選択されている就業場所の雇用契約IDに合わせてURLを書き換える
            window.history.replaceState('', '', selectedSyuugyouBasyoOption.value.koyou_id.toString())
          }
        }
      } else {
        selectedSyuugyouBasyoOption.value = hakenListData.value.syuugyouBasyo
      }

      await getKintaiSummaryBySummaryId(kintaiSummaryId.value)
      isLoading.value = false
    });

    const loadKinmuListBySummaryId = async () => {
      if (!kintaiSummaryId.value) {
        return
      }

      await getHakenKinmuListBySummaryId(kintaiSummaryId.value)
      await calcProc();
      await getKintaiSummaryBySummaryId(kintaiSummaryId.value)
    }

    const loadKinmuListByPeriod = async () => {
      // 総務は雇用契約に基づく就業場所を選択できるため、実行時点でのselectedSyuugyouBasyoOptionから就業場所IDと雇用契約IDを取得する
      // そうではない場合（主に派遣先上長で操作している場合）は前画面から渡されたクエリ文字列から取得する
      let syuugyouBasyoId = null
      let koyouKeiyakuId = null
      if (syuugyouBasyoOptions.value.length > 0) {
        // 就業場所一覧がある場合（総務など勤務先を指定して勤務一覧を取得できる場合）
        syuugyouBasyoId = selectedSyuugyouBasyoOption.value ? selectedSyuugyouBasyoOption.value.val : (route.query.mst_syuugyou_basyo_id ? parseInt(route.query.mst_syuugyou_basyo_id as string, 10) : null)
        koyouKeiyakuId = selectedSyuugyouBasyoOption.value ? selectedSyuugyouBasyoOption.value.koyou_id : (route.query.koyou_keiyaku_id ? parseInt(route.query.koyou_keiyaku_id as string, 10) : null)
      } else {
        syuugyouBasyoId = hakenListData.value ? hakenListData.value.syuugyouBasyoId : (route.query.mst_syuugyou_basyo_id ? parseInt(route.query.mst_syuugyou_basyo_id as string, 10) : null)
        koyouKeiyakuId = hakenListData.value ? hakenListData.value.koyouKeiyakuId : (route.query.koyou_keiyaku_id ? parseInt(route.query.koyou_keiyaku_id as string, 10) : null)
      }

      console.log("selectedYear.value", selectedYear.value)
      console.log("selectedMonth.value", selectedMonth.value)
      console.log("userId.value", userId.value)
      console.log("syuugyouBasyoId", syuugyouBasyoId)
      console.log("koyouKeiyakuId", koyouKeiyakuId)
      if ((!selectedYear.value || !selectedMonth.value || !userId.value || !syuugyouBasyoId)) {
        return
      }

      await getHakenKinmuListByPeriod(
        selectedYear.value,
        selectedMonth.value,
        syuugyouBasyoId,
        koyouKeiyakuId,
        userId.value
      )
      await calcProc()
      await getKintaiSummaryBySummaryId(kintaiSummaryId.value)
    }

    // MonthPickerで年月を決定した際に実行
    const changeMonth = async (val: MonthPickerModelValue) => {
      isLoading.value = true
      selectedMonth.value = val.month + 1 // プログラム上の月番号と表示上の月名の補正
      selectedYear.value = val.year

      yearMonthForMonthPicker.value = {
        year: selectedYear.value,
        month: selectedMonth.value - 1
      }

      await loadKinmuListByPeriod()
      isLoading.value = false
    };

    // 集計処理
    const calcProc = async () => {
      await calcForEach();

      // 総務修正後の合計時間を計算
      await calcSoumuModifySum();

      // 総務修正分の縦計を計算
      await calcAllSoumuModifyTime();
    };

    // 個々の総務編集を集計
    const calcForEach = async () => {
      if (!hakenListData.value) {
        return
      }
      for (let i = 0; i < hakenListData.value.list.length - 1; i++) {
        calcItem(i);
      }
    };

    // 総務の入力を受けて、派遣先用の勤務時間を計算する
    const calcItem = (idx: number) => {
      if (!hakenListData.value) {
        return
      }
      const soumuNote2HourStr = hakenListData.value.list[idx].kinmus[0].soumu_note2
      if (!soumuNote2HourStr || typeof soumuNote2HourStr === 'undefined') {
        return;
      }

      const soumuNote2Hour = cloneDeep(parseFloat(soumuNote2HourStr))
      if (soumuNote2Hour >= 24) {
        DialogService.error({
          text: '24時間より小さい値を入力して下さい。'
        }, true);
        return;
      }

      let workTimeStr = "1970/1/1 00:00:00";
      let syoteiWorkTimeStr = hakenListData.value.list[idx].kinmus[0].syotei_work_times;

      if (syoteiWorkTimeStr != null) {
        workTimeStr = "1970/1/1 " + syoteiWorkTimeStr;
      }

      let workTime = new Date(workTimeStr).getTime();

      // let soumuNote2HourStr = kinmuList.value[idx].kinmus[0].soumu_note2;
      let addHour = 0;
      if (soumuNote2Hour) {
        addHour = 60 * 60 * 1000 * soumuNote2Hour;
      } else {
        hakenListData.value.list[idx].kinmus[0].soumu_note2 = "00:00"
      }

      let tmpWorkTimeStr = dayjs(workTimeStr).format('HH:mm');
      let tmpWorkTime = tmpWorkTimeStr.split(":");
      let tmpWorkHour = parseInt(tmpWorkTime[0], 10) * 60 * 60 * 1000 + parseInt(tmpWorkTime[1], 10) * 60 * 1000;

      let modifyTimeStr = "00:00";

      if ((addHour < 0) && ((tmpWorkHour + addHour) < 0)) {
        modifyTimeStr = "00:00";
      } else {
        let modifiTime = new Date(workTime + addHour);
        modifyTimeStr = dayjs(modifiTime).format('HH:mm');
      }

      hakenListData.value.list[idx].kinmus[0].modifiedKinmuTimes = modifyTimeStr;

    };

    // 総務修正の合計時間を計算
    const calcSoumuModifySum = async () => {

      if (!hakenListData.value) {
        return
      }
      let tmpModifyHour = 0;
      let tmpModifyMinute = 0;

      hakenListData.value.list.forEach(function (value) {
        value.kinmus.forEach(function (val) {
          if (val.modifiedKinmuTimes !== undefined || val.modifiedKinmuTimes !== "") {

            // 修正後の時間を取得
            let modifyTime = (val.modifiedKinmuTimes !== undefined && val.modifiedKinmuTimes !== null)
              ? val.modifiedKinmuTimes
              : '';

            // 時間、分を加算
            if (modifyTime !== "") {
              let tmpModifyTime = modifyTime.split(":");
              tmpModifyHour += parseInt(tmpModifyTime[0], 10);
              tmpModifyMinute += parseInt(tmpModifyTime[1], 10);
            }
          };
        });
      });

      tmpModifyHour += Math.trunc(tmpModifyMinute / 60); // TODO: 整数値を加算
      tmpModifyMinute = tmpModifyMinute % 60; // 剰余
      sumAfterModify.value = tmpModifyHour + ':' + ('0' + tmpModifyMinute).slice(-2);
    }

    // 総務修正分の縦計値
    const allSoumuModifyTime = ref(0);

    // 総務修正分の縦計を計算
    const calcAllSoumuModifyTime = async () => {
      if (!hakenListData.value) {
        return
      }
      let modifyTime = 0;

      hakenListData.value.list.forEach(function (value) {
        value.kinmus.forEach(function (val) {

          let soumuNote2Str = val.soumu_note2;

          if (soumuNote2Str === undefined) {
            return;
          }

          if (typeof soumuNote2Str !== 'undefined' && soumuNote2Str !== "" && soumuNote2Str) {
            modifyTime += parseFloat(soumuNote2Str);

          }
        });
      });

      allSoumuModifyTime.value = modifyTime;
    }

    // 編集を保存
    const saveSoumuInfo = async () => {
      if (!hakenListData.value) {
        return
      }

      if (hakenListData.value.userId === null) {
        await DialogService.error({
          text: '対象ユーザーIDが正しくありません。'
        }, true)
        return
      }

      if (hakenListData.value.koyouKeiyakuId === null) {
        await DialogService.error({
          text: '対象の雇用契約IDが正しくありません。'
        }, true)
        return
      }

      if (hakenListData.value.syuugyouBasyoId === null) {
        await DialogService.error({
          text: '対象の就業場所が正しくありません。'
        }, true)
        return
      }

      const dialogResult = await DialogService.question({
        text: '編集を保存しますか？',
        showCancelButton: true,
        confirmButtonText: '保存します',
        cancelButtonText: 'キャンセル',
      })

      if (!dialogResult.isConfirmed) {
        return
      }
      isLoading.value = true
      // 総務編集を取得
      let soumuMemoList: SetSoumuModifyData[] = [];
      hakenListData.value.list.forEach(function (val) {
        let kinmu = val.kinmus;

        // 空は含めない
        if (kinmu[0].soumu_note1 === undefined && kinmu[0].soumu_note2 === undefined) {
          return
        }

        // 登録したデータを削除するときには空を送ることになるので、ここの処理はコメントアウト
        // // 未登録の空は含めない
        // if (kinmu[0].soumu_note1 === "" && kinmu[0].soumu_note2 === "") {
        //   return
        // }

        const soumuData: SetSoumuModifyData = {
          dakoku_date: val.datetime,
          soumu_note1: typeof kinmu[0].soumu_note1 === 'undefined' ? "" : kinmu[0].soumu_note1,
          soumu_note2: typeof kinmu[0].soumu_note2 === 'undefined' ? "" : kinmu[0].soumu_note2
        }
        soumuMemoList.push(soumuData)
      })

      const data: HakenModifyDatas = {
        user_id: hakenListData.value.userId,
        koyou_keiyaku_id: hakenListData.value.koyouKeiyakuId,
        mst_syuugyou_basyo_id: hakenListData.value.syuugyouBasyoId,
        modifies: soumuMemoList
      }

      if (await setHakenModifies(data)) {
        await loadKinmuListByPeriod()
      }
      isLoading.value = false
    }

    // 締め／解除の切り替え
    const switchCloseKintaiSummary = async (close = false) => {
      if (!kintaiSummaryId.value || !hakenListData.value) {
        return
      }

      let result = false
      if (close) {
        if (hakenListData.value.hasUncompleteDakoku) {
          await DialogService.error({
            title: '',
            text: Message.HAS_UNCOMPLETE_DAKOKU_ERROR
          })
          return
        }
        if (hakenListData.value.hasWaitShinsei) {
          await DialogService.error({
            title: '',
            text: Message.HAS_WAIT_SHINSEI_ERROR
          })
          return
        }
        result = await closeKintaiSummary(kintaiSummaryId.value, hakenListData.value.dakokuSyouninGroupId)
      } else {
        result = await closeCancelKintaiSummary(kintaiSummaryId.value)
      }

      if (result) {
        await getHakenKinmuListBySummaryId(kintaiSummaryId.value)
      }
    }

    const changeSyuugyouBasyo = async () => {
      isLoading.value = true
      await loadKinmuListByPeriod()
      isLoading.value = false
    }

    return {
      isLoading,
      timeFormat,
      changeMonth,
      OptionConst,
      yearMonthForMonthPicker,
      authStore,
      PermissionConst,
      calcProc,
      sumKinmuTime,
      sumAfterModify,
      saveSoumuInfo,
      setHakenModifies,
      allSoumuModifyTime,
      switchCloseKintaiSummary,
      kintaiSummaryId,
      hakenListData,
      selectedYear,
      selectedMonth,
      selectedSyuugyouBasyoOption,
      syuugyouBasyoOptions,
      changeSyuugyouBasyo
    };
  },
  components: {
    'kinmu-summary': KinmuSummary,
    'shinseis-title': ShinseisTitle,
  }
});
</script>

<style lang="scss" scoped>
@import '@scss/components/haken-kinmu-list.scss';
</style>
